import Firebase from 'firebase'
import prerender from './prerender.js'

var config = {
  apiKey: "AIzaSyCkQTNuJWXvrH68Jgvas3_M1NYNGteRFOM",
  authDomain: "omnipress-747.firebaseapp.com",
  databaseURL: "https://omnipress-747.firebaseio.com",
  projectId: "omnipress-747",
  storageBucket: "omnipress-747.appspot.com",
  messagingSenderId: "883578857147"
};
var DB_ROOT = 'https://console.firebase.google.com/u/0/project/'
    + config.projectId + '/database/' + config.projectId + '/data/'

//Firebase.database.enableLogging(true);
const firebaseApp = Firebase.initializeApp(config);
window.firebase = Firebase
window.firebaseApp = firebaseApp


var _state = {
  database : firebaseApp.database(),
  storage: firebaseApp.storage(),
  user : undefined,
  auth: firebaseApp.auth(),
  getCredential: function(email, password) {
    return Firebase.auth.EmailAuthProvider.credential(email, password)
  },
  onAuth : function(f) {
    firebaseApp.auth().onAuthStateChanged(f)
  },
  dbViewUrlRoot : DB_ROOT,
}

//_state.auth.setPersistence(Firebase.auth.Auth.Persistence.LOCAL)
_state.onAuth(user => _state.user = user)
_state.onAuth(function (user) {
  console.log('auth: ', user)
  if (user) {
    //signed in as user
  } else if (prerender.isInPrerender) {
    //don't create user for prerender
  } else {
    //always have at least anon user
    _state.auth.signInAnonymously()
  }
})

export default _state





// WEBPACK FOOTER //
// ./src/firebase.js